import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入页面
import Index from '@/views/Index'    // 公开首页 /
import Login from '@/views/Login'    // 登录页 /login

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/adminLogin',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  // mode: 'history', // 去掉 # 号
  routes
})

export default router